import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

export const useGetDriverOrdersQuery = ({
  id,
  search,
}: {
  id: string;
  search?: string;
}) => {
  return useQuery({
    queryKey: ["useGetDriverOrdersQuery", id, search],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`orders/${id}/drivers`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        params: { search },
      });
      return data;
    },
    enabled: !!getToken(),
  });
};
